export default __webpack_public_path__ + "static/media/icon-journalists.e3be1625.svg";